import React from 'react'
import { Dialog } from 'primereact/dialog'
import { cap } from '../../State'

export const Modal = ({
  children,
  noDismissable,
  visible = false,
  closable = true,
  style = {},
  header,
  footer,
  contentStyle = {},
  draggable = false,
  onHide = () => {}
}) => {
  const onHideFunction = () => closable ? onHide() : null
  const [darkMode] = cap.darkMode.useState()
  const { DEFAULT_THEME, SINGLE_THEME } = window._env_
  let classNameTheme
  if (SINGLE_THEME === 'true') {
    classNameTheme = DEFAULT_THEME === 'light' ? 'theme-light' : 'theme-dark'
  } else {
    classNameTheme = darkMode ? 'theme-dark' : 'theme-light'
  }
  return (
    <Dialog
      className={classNameTheme}
      contentStyle={{ ...contentStyle }}
      header={header}
      modal
      dismissableMask={!noDismissable}
      draggable={draggable}
      showHeader={!!header}
      visible={visible}
      onHide={onHideFunction}
      closable={closable}
      style={{ ...style }}
      footer={footer}
    >
      {children}
    </Dialog>
  )
}
